/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: 0 var(--nve-ref-size-200);
  --font-size: var(--nve-ref-font-size-100);
  --height: var(--nve-ref-size-800);
  --background: var(--nve-sys-interaction-field-background);
  --color: var(--nve-sys-interaction-field-color);
  --border-radius: var(--nve-ref-border-radius-sm);
  --border: var(--nve-ref-border-width-md) solid transparent;
  --border-bottom: var(--border);
  --cursor: text;
  --font-weight: normal;
  --_icon-height: var(--height);
  --_font-size: var(--font-size);
  --width: 100%;
  --max-width: 100%;
  --min-width: initial;
  width: var(--width);
  max-width: var(--max-width);
  min-width: var(--min-width);
}

:host([fit-text]) {
  --max-width: fit-content;
}

[input] {
  height: var(--height);
  background: var(--background);
  border: var(--border);
  border-bottom: var(--border-bottom);
  border-radius: var(--border-radius);
  color: var(--color);
  cursor: var(--cursor);
  width: var(--control-width);
  display: flex;
  align-content: stretch;
}

::slotted(input) {
  /* https://web.dev/accent-color/#guaranteeing-contrast */
  accent-color: var(--accent-color) !important;
  cursor: var(--cursor) !important;
  padding: var(--padding) !important;
  font-size: var(--font-size) !important;
  color: var(--color) !important;
  line-height: var(--height) !important;
  border: 0 !important;
  background: none !important;
  display: block !important;
  width: 100% !important;
  font-weight: var(--font-weight) !important;
}

nve-icon-button,
::slotted(nve-icon-button) {
  --height: var(--_icon-height);
  align-self: center;
}

::slotted(nve-button:not([slot])) {
  --font-size: var(--_font-size);
  --padding: 0 var(--nve-ref-size-200);
  --color: var(--label-color);
  --height: 100%;
}

:host([rounded]) {
  --border-radius: var(--nve-ref-border-radius-full);
}

:host([status='error']),
:host(:state(invalid)),
:host(:state(error)) {
  --border: var(--nve-ref-border-width-md) solid var(--nve-sys-support-danger-emphasis-color);
}

:host([status='success']),
:host(:state(success)) {
  --border: var(--nve-ref-border-width-md) solid var(--nve-sys-support-success-emphasis-color);
}

:host(:state(disabled)) {
  --border: var(--nve-ref-border-width-md) solid transparent;
}

:host([container='flat']) {
  --border-radius: 0;
  --box-shadow: none;
  --border-bottom: var(--nve-ref-border-width-md) solid var(--nve-ref-border-color-muted);
}

:host([container='flat']) [input] {
  background: inherit;
}

:host([container='flat']:focus-within) {
  --border-bottom: var(--nve-ref-border-width-md) solid var(--nve-ref-border-color-emphasis);
}

:host([container='flat']:focus-within) [input] {
  outline: 0 !important;
}
